import { AccessPermissions } from '@circlefin/permissions'
import { Role } from '@circlefin/permissions/roles'

import type { PermissionSet } from '@circlefin/permissions'

/**
 * Fee collection job query permission.
 * Which users are allowed to query fee collection jobs?
 */
export const FEE_COLLECTION_JOB_QUERY: PermissionSet = {
  access: AccessPermissions.protected,
  includeAny: [Role.BILLING_DASHBOARD_ROLE, Role.BILLING_DASHBOARD_READ_ROLE],
}
